export default function generateUuid(length: number = 24){
  let d = new Date().getTime();
  return ''.padStart(length, 'x').replace(/[x]/g, function () {
    const r = (d + Math.random()*16)%16 | 0;
    d = Math.floor(d/16);
    return (Math.random() > 0.5 ? r : (r&0x3|0x8)).toString(16);
  });
}